import { EyeOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import React, { useState } from "react";

const IMAGE_EXT = ["png", "jpg", "jpeg", "gif", "webp"];

/** What the inline viewer can show for an upload, or null if it can't show it. */
export function previewKind(file) {
  const name = (file?.files?.name || "").toLowerCase();
  const ext = name.split(".").pop();
  if (ext === "pdf") return "pdf";
  if (IMAGE_EXT.includes(ext)) return "image";
  return null;
}

/**
 * One attachment row: the file name, plus an eye button that opens it in a modal
 * on this page rather than a new tab.
 *
 * The PDF is shown as a plain page: the browser viewer's toolbar and side panel
 * are hidden for everyone, via the viewer's open parameters. Those parameters are
 * honoured by Chrome and Edge; other browsers may still show their own controls.
 *
 * `viewOnly` additionally drops the plain link for files the viewer can't show.
 * It is a deterrent, not a lock: the file still lives at a public CDN address, so
 * a determined user can find it. The Schedule export is the part that is actually
 * enforced server-side.
 */
function FilePreview({ file, viewOnly = false }) {
  const [open, setOpen] = useState(false);
  const url = file?.files?.original;
  const name = file?.files?.name || "Attachment";
  const kind = previewKind(file);

  return (
    <>
      <div className="flex items-center justify-between gap-4">
        {kind || viewOnly ? (
          <span className="text-base">{name}</span>
        ) : (
          // A file the viewer can't render keeps its link when downloads are allowed.
          <a href={url} target="_blank" rel="noreferrer" className="text-blue-500">
            {name}
          </a>
        )}
        {kind && (
          <Button
            type="text"
            aria-label={`View ${name}`}
            icon={<EyeOutlined />}
            onClick={() => setOpen(true)}
          />
        )}
      </div>

      <Modal
        title={name}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width={900}
        destroyOnClose
      >
        {kind === "pdf" ? (
          <iframe
            title={name}
            src={`${url}#toolbar=0&navpanes=0&statusbar=0&view=FitH`}
            style={{ width: "100%", height: "70vh", border: 0 }}
          />
        ) : (
          <img
            src={url}
            alt={name}
            style={{ maxWidth: "100%", maxHeight: "70vh", display: "block", margin: "0 auto" }}
          />
        )}
      </Modal>
    </>
  );
}

export default FilePreview;
